<template>
  <div data-v-0a914d54="" class="games-page-inner">
    <img style="width: 100%; display: none" src="/static/image/73b07f2.jpg" alt="" />

    <div data-v-0a914d54="" class="games-page-content" style="padding-top: 12px; display: none">
      <div data-v-0a914d54="" class="games-tab-wrapper">
        <!-- stuck -->
        <ul data-v-0a914d54="" class="games-tab clearfix">
          <li data-v-0a914d54="" :class="gamecode == null ? 'games-tab-item active' : 'games-tab-item'" @click="changgamecode(null)">推荐</li>
          <li data-v-0a914d54="" :class="gamecode == 'obgdy' ? 'games-tab-item active' : 'games-tab-item'" @click="changgamecode('obgdy')">OB电子</li>
          <li data-v-0a914d54="" :class="gamecode == 'fgdz' ? 'games-tab-item active' : 'games-tab-item'" @click="changgamecode('fgdz')">FG电子</li>
          <li data-v-0a914d54="" :class="gamecode == 'pp' ? 'games-tab-item active' : 'games-tab-item'" @click="changgamecode('pp')">PP电子</li>
          <li data-v-0a914d54="" :class="gamecode == 'ae' ? 'games-tab-item active' : 'games-tab-item'" @click="changgamecode('ae')">AE电子</li>
        </ul>
      </div>
      <ul data-v-0a914d54="" class="game-list clearfix" v-if="gamecode == null">
        <!-- AT -->
        <li data-v-0a914d54="" v-for="(item, index) in gameList" :key="index" v-if="item.app_state == 1" class="game-list-item" @click="$parent.openGamePage(item.platform_name, item.game_code, '', item.supplier)">
          <div data-v-0a914d54="" class="game-cover-wrapper">
            <img data-v-0a914d54="" alt="" class="game-picture" :src="`/static/image/concise/${item.platform_name}dz.png`" lazy="loaded" />
          </div>
          <h4 data-v-0a914d54="" class="game-title">{{ item.name }}</h4>
        </li>
      </ul>
      <ul data-v-0a914d54="" class="game-list clearfix" v-if="gamecode == 'obgdy'">
        <li data-v-0a914d54="" class="game-list-item" v-for="(item, index) in obgdyList" :key="index" @click="$parent.openGamePage(item.catecode, item.gamecode, '', item.supplier)">
          <div data-v-0a914d54="" class="game-cover-wrapper">
            <img data-v-0a914d54="" alt="" class="game-picture" :src="item.gamepic" lazy="loaded" />
          </div>
          <h4 data-v-0a914d54="" class="game-title">{{ item.gamename }}</h4>
        </li>
      </ul>
      <ul data-v-0a914d54="" class="game-list clearfix" v-if="gamecode == 'fgdz'">
        <li data-v-0a914d54="" class="game-list-item" v-for="(item, index) in fgdzList" :key="index" @click="$parent.openGamePage(item.catecode, item.gamecode, '', item.supplier)">
          <div data-v-0a914d54="" class="game-cover-wrapper">
            <img data-v-0a914d54="" alt="" class="game-picture" :src="item.gamepic" lazy="loaded" />
          </div>
          <h4 data-v-0a914d54="" class="game-title">{{ item.gamename }}</h4>
        </li>
      </ul>
      <ul data-v-0a914d54="" class="game-list clearfix" v-if="gamecode == 'pp'">
        <li data-v-0a914d54="" class="game-list-item" v-for="(item, index) in ppList" :key="index" @click="$parent.openGamePage(item.catecode, item.gamecode, '', item.supplier)">
          <div data-v-0a914d54="" class="game-cover-wrapper">
            <img data-v-0a914d54="" alt="" class="game-picture" :src="item.gamepic" lazy="loaded" />
          </div>
          <h4 data-v-0a914d54="" class="game-title">{{ item.gamename }}</h4>
        </li>
      </ul>
      <ul data-v-0a914d54="" class="game-list clearfix" v-if="gamecode == 'ae'">
        <li data-v-0a914d54="" class="game-list-item" v-for="(item, index) in aeList" :key="index" @click="$parent.openGamePage(item.catecode, item.gamecode, '', item.supplier)">
          <div data-v-0a914d54="" class="game-cover-wrapper">
            <img data-v-0a914d54="" alt="" class="game-picture" :src="item.gamepic" lazy="loaded" />
          </div>
          <h4 data-v-0a914d54="" class="game-title">{{ item.gamename }}</h4>
        </li>
      </ul>
    </div>
    <div style="min-height: calc(100vh - 55px); background-color: #282828">
      <van-sticky offset-top="50">
        <div style=" background-color: #282828;padding: 10px 0 20px;">
        <div class="game-list-tab">
          <van-tabs v-model="active" color="#cca352" title-active-color="#cca352" title-inactive-color="#fff" background="#282828">
            <van-tab v-for="(item, index) in tabs" :key="index" :name="item.id">
              <template #title>
                <div :class="active == item.id ? 'ac' : 'noac'" @click="tabClick(item)">
                  <img :src="item.game_img" style="width: 24px; height: 24px; margin-top: 7px" />
                  <p style="width: 60px;">
                    {{ item.name }}
                  </p>
                </div>
              </template>
            </van-tab>
          </van-tabs>
        </div>
        <div style="margin: 0px 10px" class="search-game-list">
          <van-field v-model="searchVal" right-icon="search" placeholder="请输入游戏名" @input="changeInput">
            <template #right-icon>
              <van-icon name="search" size="22" color="#fff" />
            </template>
          </van-field>
        </div>
        </div>
      </van-sticky>
      <div class="game-list-game">
        <van-grid :border="false">
          <van-grid-item v-for="(item, index) in games" :key="index">
            <div @click="$parent.openGamePage(item.platform_name, item.game_code, '', item.supplier)" style="text-align: center;position: relative;">
              <div v-if="item.desc_mark && item.desc_mark.length > 0" style="position: absolute;top: 0px;left: 0px;color: #fff;padding: 3px 5px;font-size: 12px;border-top-left-radius: 10px;" :style="'background:' + item.mark_color">
                      {{ item.desc_mark || '' }}
                    </div>
              <div style="width: 100%;">
                <img data-v-5648ec66="" :src="item.mobile_img" lazy="loaded" style="width: 100%; border-radius: 8px" />
              </div>
              <div style="width: calc(100vw / 4 - 30px); margin-top: 2px; font-size: 13px; margin-bottom: 2px; color: #c2bbc6; white-space: nowrap; overflow: hidden;">{{ item.name }}</div>
            </div>
          </van-grid-item>
        </van-grid>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'games',
  data () {
    return {
      gamecode: null,
      obgdyList: [],
      fgdzList: [],
      ppList: [],
      aeList: [],
      gameList: [],
      value1: null,
      gametype: null,
      pfId: null,
      /*******/
      active: null,
      tabs: [],
      searchVal: null,
      games: [],
      tmpgames: [],
    };
  },
  created () {
    let that = this;

    // that.getGameList();
  },
  methods: {
    getData () {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/gameLobby', { category_id: this.pfId }).then(res => {
        if (res.code == 200) {
          that.tabs = res.data.siblings;
          this.games = res.data.games;
          this.tmpgames = res.data.games;
          that.tabs.forEach(element => {
            if (element.is_current) {
              this.active = element.id;
            }
          });
        }
        that.$parent.hideLoading();
      });
    },

    getGameList () {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun.get('/api/game/list', { category: 'concise' }).then(res => {
        if (res.code == 200) {
          that.gameList = res.data;
        }
        that.$parent.hideLoading();
      });
    },
    changgamecode (code) {
      let that = this;
      if (code == that.gamecode) {
        return;
      }
      that.gamecode = code;
      if (code != null) {
        that.gamelistBycode();
      }
    },
    gamelistBycode () {
      let that = this;

      let name = that.gamecode + 'List';
      if (that[name].length > 0) {
        return;
      }
      that.$parent.showLoading();

      that.$apiFun
        .post('/api/gamelistBycode', { gamecode: that.gamecode })
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that[name] = res.data;
          }
          setTimeout(() => {
            that.$parent.hideLoading();
          }, 2000);
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    changeInput (val) {
      console.log(val);
      if (val.length > 0) {
        this.games = JSON.parse(JSON.stringify(this.tmpgames.filter(e => e.name.indexOf(val) != -1)));
      } else {
        this.games = JSON.parse(JSON.stringify(this.tmpgames));
      }
    },
    tabClick (val) {
      this.pfId = val.id;
      this.getData();
    },
  },
  mounted () {
    let that = this;
    var mySwiper = new Swiper('.swiper', {
      slidesPerView: '1',
    });
    $(window).scroll(function () {
      if ($(document).scrollTop() <= 50) {
        $('.header-container').removeClass('headerBg');
        $('#headerBefore').css('height', '');
      } else {
        $('.header-container').addClass('headerBg');
        $('#headerBefore').css('height', '50px');
      }
    });
    console.log(this.$route.query);
    this.pfId = this.$route.query.pyid;
    this.gametype = this.$route.query.type;
    this.getData();
  },
  updated () {
    let that = this;
  },
};
</script>
<style>

.search-game-list .van-cell {
  background-color: #000 !important;
  border-radius: 8px;
}
.search-game-list .van-cell .van-field__control {
  color: #fff !important;
}
.search-game-list .van-cell .van-icon {
  color: #fff !important;
}
.game-list-tab .van-tabs__wrap {
  height: 60px !important;
  margin: 10px 0;
}
.game-list-tab .van-tab__text--ellipsis {
  display: grid;
  text-align: center;
}
.game-list-tab .van-tab {
  padding: 5px;
}
.game-list-tab .noac {
  border-radius: 8px;
  padding: 10px 20px;
  margin: 5px 0;
    text-align: center;
}
.game-list-game .van-grid-item__content {
  background-color: rgb(0, 0, 0, 0) !important;
}
.ac {
  color: #cca352 !important;
  border-radius: 8px;
  padding: 10px 20px;
  margin: 5px 0;
    text-align: center;
}
  
</style>
<style lang="scss" scoped>
@import '../../../static/css/chunk-4f15c2b0.7a52835c.css';
@import '../../../static/css/chunk-vendors.2272e24f.css';
@import '../../../static/css/chunk-commonPlugins.f49730d2.css';
.games-page-content .games-tab.stuck {
  position: fixed !important;
  top: 50px !important;
  z-index: 600 !important;
  width: 100% !important;
}
.games-page-content .game-list .game-cover-wrapper {
  height: 218px !important;
}
.games-page-content .game-list .game-picture {
  height: auto !important;
}

.games-page-content .games-tab .games-tab-item {
  margin: 0 8px !important;
  font-size: 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/main/games.vue